import { createAction } from "redux-starter-kit";

export const signinSuccess = createAction("SIGNIN_SUCCESS");

export const signoutSuccess = createAction("SIGNOUT_SUCCESS");

